import {filesExtension, TEN_MEGABYTES_IN_BYTES} from "../../Constants/StaticData";
import {toBase64} from "../toBase64/toBase64";

export const validateFile = async (
    event: any,
    setDocumentErrorModalText: any,
    setIsDocumentErrorModalOpen: any
) => {
    const file = event.currentTarget.files?.[0]

    if (!file) {
        return;
    }

    if (!filesExtension.includes(file.type)) {
        setDocumentErrorModalText("Invalid file format!")
        setIsDocumentErrorModalOpen(true)
        return
    } else if (file && (file.size > TEN_MEGABYTES_IN_BYTES)) {
        event.target.value = '';
        setDocumentErrorModalText("Max file size is 10 Mb.")
        setIsDocumentErrorModalOpen(true)
        return
    }

    try {
        const base64Data = await toBase64(file)
        const fileData = {
            name: file.name,
            data: base64Data
        };
        return fileData
    }
    catch (error) {
        console.log(error)
    }
}
